<div>
  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-person-lines-fill me-2"></i>
      Customers
      <span *ngIf="!loading" class="badge bg-secondary ms-2">{{ totalCustomers }}</span>
    </h5>
  </div>

  <!-- Search -->
  <div class="mb-3">
    <div class="input-group" style="max-width: 400px;">
      <span class="input-group-text">
        <i class="bi bi-search"></i>
      </span>
      <input
        type="text"
        class="form-control"
        placeholder="Search customers..."
        [(ngModel)]="searchQuery"
        (keyup.enter)="onSearch()"
      />
      <button class="btn btn-outline-secondary" type="button" (click)="onSearch()">
        Search
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading customers...</p>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && !errorMessage">
    <!-- Empty State -->
    <div *ngIf="customers.length === 0" class="text-center py-5 text-muted">
      <i class="bi bi-person-lines-fill fs-1 d-block mb-3"></i>
      <p *ngIf="searchQuery">No customers found matching "{{ searchQuery }}"</p>
      <p *ngIf="!searchQuery">No customers found for this organization</p>
    </div>

    <!-- Customers Table -->
    <div *ngIf="customers.length > 0">
      <div class="table-responsive">
        <table class="table data-table table-hover mb-0">
          <thead>
            <tr>
              <th style="width: 30px;"></th>
              <th>Name</th>
              <th>City / State</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Fields</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let customer of customers">
              <!-- Customer Row -->
              <tr class="cursor-pointer" (click)="toggleCustomer(customer.id)">
                <td>
                  <i class="bi" [ngClass]="isExpanded(customer.id) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                </td>
                <td>
                  <span class="fw-medium">{{ customer.name || '-' }}</span>
                </td>
                <td>{{ formatLocation(customer.city, customer.state) }}</td>
                <td>{{ (customer.phone | phoneFormat) || '-' }}</td>
                <td>{{ customer.email || '-' }}</td>
                <td>
                  <span class="badge bg-secondary">{{ customer.fieldCount || 0 }}</span>
                </td>
              </tr>

              <!-- Expanded Fields Sub-table -->
              <tr *ngIf="isExpanded(customer.id)">
                <td colspan="6" class="p-0">
                  <div class="bg-body-tertiary border-top p-2">
                    <!-- Fields Loading -->
                    <div *ngIf="isLoadingFields(customer.id)" class="text-center py-3">
                      <div class="spinner-border spinner-border-sm text-secondary" role="status">
                        <span class="visually-hidden">Loading fields...</span>
                      </div>
                      <span class="ms-2 text-muted">Loading fields...</span>
                    </div>

                    <!-- Fields Table -->
                    <div *ngIf="!isLoadingFields(customer.id) && getFields(customer.id).length > 0">
                      <table class="table table-sm small mb-0">
                        <thead>
                          <tr>
                            <th>Field Name</th>
                            <th>Acreage</th>
                            <th>Crop Type</th>
                            <th>City / State</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let field of getFields(customer.id)">
                            <td>{{ field.name || '-' }}</td>
                            <td>{{ field.acreage || '-' }}</td>
                            <td>{{ field.cropType || '-' }}</td>
                            <td>{{ formatLocation(field.city, field.state) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- No Fields -->
                    <div *ngIf="!isLoadingFields(customer.id) && getFields(customer.id).length === 0" class="text-center py-3 text-muted">
                      <small>No fields found for this customer</small>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Pagination Footer -->
      <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalCustomers > 0">
        <div class="text-muted">
          Showing {{ showingStart }} to {{ showingEnd }} of {{ totalCustomers }} customers
        </div>
        <nav *ngIf="totalPages > 1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" (click)="onPageChange(currentPage - 1)">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li
              *ngFor="let page of paginationRange"
              class="page-item"
              [class.active]="page === currentPage"
            >
              <button class="page-link" (click)="onPageChange(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link" (click)="onPageChange(currentPage + 1)">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
